import { api } from 'app/config/apiConfig';
import { VatRate } from '../model/types';

export const getVatRatesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getVatRates: build.query<VatRate[], void>({
      query: () => ({
        url: 'vat-rate/general',
      }),
    }),
  }),
});

export const { useGetVatRatesQuery } = getVatRatesApi;
